import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {displayToast, removeToast} from './actions';


const withDispatch = connect(() => ({}), {
    _displayToast: displayToast,
    _removeToast: removeToast
});

export const WithManageToasts = withDispatch(({render, _displayToast, _removeToast}) => (
    render(_displayToast, _removeToast)
));

WithManageToasts.propTypes = {
    render: PropTypes.func.isRequired
};

export function withManageToasts(Component) {
    const Wrapper = (props) => (
        <WithManageToasts render={(_displayToast, _removeToast) => (
            <Component displayToast={_displayToast} removeToast={_removeToast} {...props}/>
        )}/>
    );
    return Wrapper;
}
